import React, {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {Platform, ScrollView, Text} from 'react-native';
import * as Yup from 'yup';
import BottomNavigation from '../../../components/BottomNavigation';
import Button from '../../../components/Button';
import ChallengeFull from './components/ChallengeFull';
import Div from '../../../lib/Div';
import FriendChallengeDetails from './components/FriendChallengeDetails';
import FriendChallengeDetailsForm from './components/FriendChallengeDetailsForm';
import Input from '../../../components/Input';
import InvalidCodeModal from './components/InvalidCodeModal';
import MainStyle from '../../../../MainStyle';
import NewHeader from '../../../components/NewHeader';
import {colors} from '../../../assets/styles/colors';
import {useFormik} from 'formik';
import AsyncStorage from "@react-native-async-storage/async-storage";
import moment from "moment";
import {BrandName, isFullSwing, SESSION_EXPIRE_TIME} from "../../../constants";
import {
  ListTournamentRequest_Sort, ListTournamentRequest_TournamentAccess,
  Tournament, TournamentPlayerBet_State, TournamentState, TournamentSurveyQuestionType, User
} from "../../../../generated/smg_service_pb";
import {StoreContext} from "../../../components/StoreContextProvider";
import useMaskedInput from "../../../utils/useMaskedInput";
import {useIsFocused, useNavigation, useRoute} from "@react-navigation/native";
import ServiceClient from "../../../utils/ServiceClient";
import {CancelModalProps} from "../../../types";
import P from "../../../lib/P";
import InsufficientFundsPopup from "../../../modals/InsufficientFundsPopup";
import LoginWithPin from "../../LoginWithPin";
const Sort = ListTournamentRequest_Sort;
const TournamentAccess = ListTournamentRequest_TournamentAccess;
import AdditionalSurveyQuestions from "../../../modals/AdditionalSurveyQuestions";
import {getFieldError} from "../../../utils";
import FSHeader from "../../../components/FSHeader";
import FontAwesome from "@expo/vector-icons/FontAwesome";

const mask = [/\d/, /\d/, /\d/, /\d/];

const FriendsScreen = () => {
  const [challengeFull, setChallengeFull] = useState(false);
  const [invalidCodeModal, setInvalidCodeModal] = useState('');
  const [friendChallengeDetailsForm, setFriendChallengeDetailsForm] = useState(false);
  const formik = useFormik({
    initialValues: {code: ''}, validationSchema: Yup.object({code: Yup.string().matches(/^\d+$/).length(4).required()}),
    onSubmit: () => {
      console.log('submit');
    }
  });
  const Context = useContext(StoreContext);
  const {cancelModalConfig, user, session} = Context;
  const numberMaskedInputProps = useMaskedInput({
    value: formik.values.code, onChangeText: formik.handleChange('code'), mask
  });
  const isFocused = useIsFocused();
  const navigation: any = useNavigation();
  const [tournament, setTournament] = useState<Tournament>();
  const route = useRoute();
  const params: any = route?.params;
  const code = params?.code;
  const [showInsufficientFundsPopup, setShowInsufficientFundsPopup] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [showAdditionalSurveyQuestions, setShowAdditionalSurveyQuestions] = useState(false);
  const initialValues: Record<string, string[]> = tournament?.questions.reduce((values, question) => {
    values[question.id] = [];
    return values;
  }, {} as Record<string, string[]>) || {} as Record<string, string[]>;
  const validationSchema = Yup.object(
    tournament?.questions.reduce((schema, question) => {
      if (question.type === TournamentSurveyQuestionType.MULTI_CHOICE) {
        schema[question.id] = Yup.array().min(1, 'Please select at least one option').required('This field is required');

      } else {
        schema[question.id] = Yup.array().of(Yup.string()).test('is-single-value', 'This field is required', (value) => Array.isArray(value) && value.length === 1 && !!value[0]).required('This field is required');
      }
      return schema;
    }, {} as Record<string, any>)
  );
  const questionFormik = useFormik<Record<string, string[]>>({
    initialValues, validationSchema,
    onSubmit: () => {
      setShowAdditionalSurveyQuestions(false);
      joinPrivateTournament();
    }
  });
  const isSponsored = typeof params?.isSponsored === 'string' ? params?.isSponsored === 'true' : !!params?.isSponsored;

  const joinPrivateTournament = () => {
    setTournament(undefined);
    Context.setLoadingOverlay(true);

    ServiceClient.joinPrivateTournament(code || formik.values.code, questionFormik.values).then(res => {
      navigation.navigate('TournamentDetails', {id: res?.id, isPrivateTournament: true, showPopup: true});

    }).catch(err => {
      console.log('joinPrivateTournament err', err);
      Context.setLoadingOverlay(false);

      if (err.message.includes('balance')) {
        setShowInsufficientFundsPopup(true);

      } else {
        Context.setCancelModalConfig({
          visible: true, title: 'Error', subtitle: err.message, rightBtnText: 'OK',
          onResume: () => {
            Context.setCancelModalConfig({...cancelModalConfig, visible: false});
            navigation.reset({index: 0, routes: [{name: 'FriendsScreen'}]});
          }
        });
      }
    });
  };

  const verifyPrivateTournamentCode = (code: string) => {
    Context.setLoadingOverlay(true);

    ServiceClient.verifyPrivateTournamentCode(code).then(res => {
      Context.setLoadingOverlay(false);
      setTournament(res);

    }).catch(err => {
      console.log('verifyPrivateTournamentCode err', err);
      Context.setLoadingOverlay(false);

      if (err.code === 20020068) {
        setInvalidCodeModal(`Sorry but this\nFriend Challenge\ncode is invalid.`);

      } else if (err.code === 20020071) {
        setChallengeFull(true);

      } else {
        setInvalidCodeModal(`Sorry but this Friend Challenge\nhas expired or the Challenge\nhas been completed.`);
      }
    });
  };

  const getActivePrivateTournament = (showPopup: boolean = false) => {
    ServiceClient.listTournaments([TournamentState.PLAYING], Sort.ENTRY_BEGIN_DATE_LATEST, [TournamentAccess.FRIENDS], true).then(res => {
      Context.setLoadingOverlay(false);

      const tournament = res.find(el => {
        const currentNumberOfShots = el?.currentPlayerDetails?.bets.filter(bet => bet.state === TournamentPlayerBet_State.FINISHED && bet.resolved).length || 0;
        return currentNumberOfShots !== el.totalShots;
      });

      if (code) {
        verifyPrivateTournamentCode(code);

      } else if (!!tournament) {
        navigation.navigate('TournamentDetails', {id: tournament.id, isPrivateTournament: true, showPopup});
      }

    }).catch(err => {
      console.log('listTournaments err', err);
      Context.setLoadingOverlay(false);

      let conf: CancelModalProps = {
        visible: true, title: 'ERROR', leftBtnText: 'OK', subtitle: err.message,
        onExit: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
          // if (err.code !== 20020042) navigation.navigate({name: 'account', params: {step: 1}});
        }
      };

      Context.setCancelModalConfig(conf);
    });
  };

  const getUser = () => {
    Context.getUser().catch(err => {
      console.log('getUser err', err);
      setTimeout(() => {
        getUser();
      }, 5000);
    });
  };

  useEffect(() => {
    if (user?.kycStatus === 6) {
      Context.setLoadingOverlay(false);

      Context.setCancelModalConfig({
        visible: true, title: 'ERROR', leftBtnText: 'Cancel', rightBtnText: 'Contact Support',
        subtitle: `Your Know Your Customer information and registration information do not match. Your account with ${BrandName} has been locked. Please contact support to resolve this issue.`,
        onResume: () => {
          if (Platform.OS === 'web') {
            window.open('https://smgames.atlassian.net/servicedesk/customer/portal/3', '_self');
          }
        },
        onClose: () => {
          Context.setCancelModalConfig({...cancelModalConfig, visible: false});
          navigation.navigate({name: 'account', params: {step: 0}});
        }
      });
    }
  }, [user?.kycStatus]);

  useEffect(() => {
    if (!user || !isFocused || isLogout) return;

    getActivePrivateTournament();
    setIsLogout(false);

    const time = setTimeout(() => {
      getUser();
    }, 1000 * 30);

    return () => {
      clearTimeout(time);
    };
  }, [user, isFocused, isLogout]);

  useEffect(() => {
    if (!isFocused) return;

    const time = setInterval(() => {
      (async () => {
        const lastActiveTime = await AsyncStorage.getItem('lastActiveTime');

        if (lastActiveTime && moment().diff(moment(lastActiveTime), 'minutes') > SESSION_EXPIRE_TIME) {
          Context.logout().then(() => {
            Context.setLoadingOverlay(false);
            setIsLogout(true);
          });
        }
      })();
    }, 1000 * 60);

    return () => {
      clearInterval(time);
    };
  }, [isFocused]);

  useLayoutEffect(() => {
    Context.setLoadingOverlay(true);

    if (!session || !user) {
      (async () => {
        const time = await AsyncStorage.getItem('lastActiveTime');

        if (time && moment().diff(moment(time), 'minutes') > SESSION_EXPIRE_TIME) {
          Context.logout().then(() => {
            Context.setLoadingOverlay(false);
            setIsLogout(true);
          });

        } else {
          const val = await AsyncStorage.getItem('session');
          let curUser: User | undefined;

          if (val) {
            const Session = JSON.parse(val);
            Context.setSession(Session);

            try {
              curUser = await Context.getUser(Session);

            } catch (e: any) {
              Context.setCancelModalConfig({
                visible: true, title: 'Error', subtitle: e?.message || 'Error', rightBtnText: 'OK',
                onResume: () => Context.setCancelModalConfig({...cancelModalConfig, visible: false})
              });
            }
          }

          if (!val || !curUser || !curUser.userId) {
            Context.logout().then(() => {
              Context.setLoadingOverlay(false);
              setIsLogout(true);
            });

          } else console.log('user', curUser);
        }
      })();
    }
  }, []);

  return (
    <>
      {isLogout ? <LoginWithPin onSuccessLogin={() => setIsLogout(false)}/> : (
        <>
          {isFullSwing ? (
            <>
              <FSHeader px={20}/>

              <Div h={2} bg="#252526"/>

              <Div gap={5} py={10} px={20}>
                <Div row alignItems="center">
                  <Div w={24} alignItems="center"><FontAwesome name="user-circle" size={24} color="#3399FF"/></Div>
                  <P fontFamily="DavisSans-Regular" ml={6}>{user?.username}</P>
                </Div>
              </Div>

              <Div h={2} bg="#252526"/>
            </>
          ) : <NewHeader pb={11}/>}

          <ScrollView contentContainerStyle={MainStyle.flex1}>
            <P color="white" fw="500" fs={30} mx={20} mt={isFullSwing ? 13 : undefined} mb={13}>
              Play With Friends
            </P>

            <Div flex={1} alignItems="center" justifyContent="center">
              <Div w={368} rounded={isFullSwing ? 4 : 20} bg={isFullSwing ? 'black' : colors.settings_bg} mb={30}
                   borderColor={isFullSwing ? 'rgba(255, 255, 255, 0.30)' : colors.settings_border} borderWidth={1}>
                <Text style={styles.subtitle}>
                  {isSponsored ? 'Enter Tournament Code:' : `Enter Friend\nChallenge Code:`}
                </Text>

                <Div w={240} h={60} rounded={20} borderColor={colors.settings_border} borderWidth={1} mx="auto"
                     bg={isFullSwing ? '#252526' : 'black'} mb={30}>
                  <Input
                    type="numeric" placeholder="____" {...numberMaskedInputProps} w={185} mx="auto" h={58}
                    inputStyles={styles.input} placeholderTextColor="white" onBlur={formik.handleBlur('code')}
                    error={getFieldError('code', formik)}
                  />
                </Div>

                <Button
                  text={isSponsored ? 'Enter Tournament' : 'Enter Existing Challenge'} w={280} mx="auto"
                  fontWeight="600" mb={44} disabled={formik.errors.code !== undefined || formik.values.code.length < 4}
                  onPress={() => verifyPrivateTournamentCode(formik.values.code)} radius={isFocused ? 4 : undefined}
                  bg={isFullSwing ? '#3369FF' : undefined} color={isFullSwing ? 'white' : undefined}
                />
              </Div>

              {isFullSwing && <Div flex={1}/>}

              {!isSponsored && (
                <>
                  <Button
                    text="Start New Friend Challenge" w={350} mx="auto" fontWeight="600" borderWidth={1}
                    borderColor={isFullSwing ? '#4C4C4C' : 'white'} onPress={() => setFriendChallengeDetailsForm(true)}
                    color="white" mb={20} radius={isFocused ? 4 : undefined}
                    bg={isFullSwing ? '#252526' : colors.mainBackground}
                  />

                  <Button
                    text="See Completed Challenges" w={350} mx="auto" fontWeight="600" borderWidth={1} color="white"
                    mb={10} radius={isFocused ? 4 : undefined}
                    borderColor={isFullSwing ? '#4C4C4C' : 'white'} bg={isFullSwing ? '#252526' : colors.mainBackground}
                    onPress={() => navigation.reset({index: 0, routes: [{name: 'CompletedFriendChallenges'}]})}
                  />
                </>
              )}
            </Div>

            <P ta="center" fw={500} mb={20} color={colors.gray}>Malfunction voids all pays and plays</P>
          </ScrollView>

          {!isFullSwing && <BottomNavigation page="FriendsScreen"/>}

          <FriendChallengeDetails
            tournament={tournament} isSponsored={isSponsored}
            onConfirm={() => {
              if (tournament?.questions.length) setShowAdditionalSurveyQuestions(true);
              else joinPrivateTournament();
            }}
            onClose={() => {
              setTournament(undefined);
              navigation.reset({index: 0, routes: [{name: 'FriendsScreen'}]});
            }}
          />

          <ChallengeFull
            isOpen={challengeFull} onClose={() => setChallengeFull(false)}
            startNewChallenge={() => setFriendChallengeDetailsForm(true)}
          />

          <InvalidCodeModal
            message={invalidCodeModal}
            onClose={() => {
              setInvalidCodeModal('');
              navigation.reset({index: 0, routes: [{name: 'FriendsScreen'}]});
            }}
          />

          <FriendChallengeDetailsForm
            isOpen={friendChallengeDetailsForm} onClose={() => setFriendChallengeDetailsForm(false)}
            onReload={() => getActivePrivateTournament(true)}
          />

          <InsufficientFundsPopup
            isOpen={showInsufficientFundsPopup}
            onClose={() => {
              setShowInsufficientFundsPopup(false);
              navigation.reset({index: 0, routes: [{name: 'FriendsScreen'}]});
            }}
          />

          {!!tournament?.questions.length && (
            <AdditionalSurveyQuestions
              visible={showAdditionalSurveyQuestions} onClose={() => setShowAdditionalSurveyQuestions(false)}
              questionsList={tournament.questions} formik={questionFormik}
            />
          )}
        </>
      )}
    </>
  );
};

const styles = {
  subtitle: [
    MainStyle.c_white, MainStyle.t_a_c, MainStyle.Barlow500, MainStyle.f_s_22, MainStyle.m_t_28, MainStyle.m_b_23
  ],
  input: [
    MainStyle.Barlow500, MainStyle.f_s_32, MainStyle.l_s_5, MainStyle.bg_transparent, MainStyle.b_w_0, MainStyle.t_a_c
  ]
};

export default FriendsScreen;
